import Constants from './Constants.js'

/**
 * Adds the ids to the specified selected group
 **/
const add = ( ids, group = 'default' ) => {
  if ( ids == null ) {
    return undefined
  }
  const wrap = !Array.isArray( ids )
  return { type : Constants.SELECT_ADD, ids : ( wrap ? [ ids ] : ids ), group }
}

/**
 * Adds the ids to the specified selected group
 **/
const set = ( ids, group = 'default' ) => {
  return { type : Constants.SELECT_SET, ids, group }
}

/**
 * Remove the ids from the specified group
 **/
const remove = ( ids, group = 'default' ) => {
  return { type : Constants.SELECT_REMOVE, ids, group }
}

/**
 * Toggles the ids from the specified group
 **/
const toggle = ( ids, group = 'default' ) => {
  return { type : Constants.SELECT_TOGGLE, ids, group }
}

/**
 * Clear the specified group
 **/
const clear = ( group = 'default' ) => {
  return { type : Constants.SELECT_CLEAR, group }
}

/**
 * Clear all groups
 **/
const clearAll = ( ) => {
  return { type : Constants.SELECT_CLEAR_ALL }
}

/**
 * Returns true if the id is selected in the specified groupData
 * @param {array} groupData this is the data from the reducer for the group
 * @param {string} id the id to lookup
 **/
const isSelected = ( groupData, id ) => {
  if ( id == null ) {
    return false
  }
  return Array.isArray( groupData ) && groupData.findIndex( e => e != null && ( e === id || e.id === id ) ) >= 0
}

/**
 * Returns the number of items in the selected group data
 * @param {array|object} groupData if this is an object, key will be used to acquire the array
 * @param {string} key used to acquire the selection array from groupData if groupData is an object.
 * This allow for invokations like: Select.count( state.select, 'rollover' ) and is equivalent to
 * Select.count( state.select.rollover )
 **/
const count = ( groupData, key ) => {
  if ( groupData == null ) {
    return 0
  }

  const arr = key == null ? groupData : groupData[key]
  return Array.isArray( arr ) ? arr.length : 0
}

const isEmpty = ( groupData, key ) => {
  return count( groupData, key ) === 0
}

const EMPTY_ARRAY = []

/**
 * Returns array store at the given key. If the value is empty, the same empty 
 * array will be returned.
 * @param {array|object} groupData if this is an object, key will be used to acquire the array
 * @param {string} key used to acquire the selection array from groupData if groupData is an object.
 * This allow for invokations like: Select.get( state.select, 'rollover' ) and is equivalent to
 * Select.get( state.select.rollover )
 * @return {array} array of selected ids
 **/
const get = ( groupData, key ) => {
  if ( groupData == null ) {
    return EMPTY_ARRAY
  }

  const arr = key == null ? groupData : groupData[key]
  if ( arr == null || !Array.isArray( arr ) || arr.length === 0 ) { 
    return EMPTY_ARRAY
  }
  return arr
}

export default {
  add,
  set,
  remove,
  toggle,
  clear,
  clearAll,
  isSelected,
  count,
  isEmpty,
  get
}
